import { getCurrentCircleLocale } from "@circle-react/helpers/localeHelpers";

export const setFullCalendarPtLocale = async (calendarApi: any) => {
  if (getCurrentCircleLocale() === "pt") {
    const ptLocale = await import(
      /* webpackChunkName: "full_calendar_pt" */ "@fullcalendar/core/locales/pt"
    );
    calendarApi.setOption("locales", [ptLocale]);
    calendarApi.setOption("locale", "pt");
  }
};
